type TEmailAction = {
  type: string;
  payload?: {
    email?: string;
    isConfirmed?: boolean;
    alreadyExists?: boolean;
    verificationCode?: number;
  };
};

const initialState = {
  email: null,
  isSent: false,
  isConfirmed: false,
  isLoading: false,
  alreadyExists: false,
  verificationCode: null,
};

export const emailConfirmationReducer = (
    state = initialState,
    action: TEmailAction
) => {
  switch (action.type) {
    case 'ACTION_EMAIL_SENT':
      return {
        ...state,
        isSent: true,
        email: action.payload?.email,
        verificationCode: action.payload?.verificationCode,
        isLoading: false,
      };
    case 'ACTION_EMAIL_CONFIRMED':
      return {
        ...state,
        isConfirmed: true,
      };
    case 'ACTION_EMAIL_EXISTS': {
      return {
        ...state,
        alreadyExists: true,
        isLoading: false,
      };
    }
    case 'ACTION_EMAIL_GETTING_DATA': {
      return {
        ...state,
        alreadyExists: false,
        isLoading: true,
      };
    }
    case 'ACTION_EMAIL_RESET': {
      return {
        ...state,
        email: null,
        isSent: false,
        isConfirmed: false,
        isLoading: false,
        alreadyExists: false,
        verificationCode: null,
      };
    }
    default:
      return state;
  }
};
